<div class="govuk-width-container">
    <div class="row">
        <nav class="col-12 col-md-4" aria-label="Side navigation">
            <p class="govuk-body h-100"><app-menu></app-menu></p>
        </nav>
        <main class="govuk-main-wrapper col-12 col-md-8 pt-0" id="main-content" tabindex="-1">
            <div>
                <h1 class="govuk-heading-xl">Give Notice</h1>
                <app-custom-object-banner page="give-notice"></app-custom-object-banner>
                <!-- <p class="govuk-body">
                    <button type="button" class="govuk-button" data-module="govuk-button">
                        Book a notice appointment
                    </button>
                </p> -->
                <ng-container *ngIf="hasRules">
<!--                     <p class="govuk-body">You should give notice between <strong>{{ dates.betweenStart }}</strong> and <strong>{{ dates.betweenEnd }}</strong>.</p>
                    <p class="govuk-body">You cannot give notice before <strong>{{ dates.before }}</strong>.</p> -->
                    <p class="govuk-body">You must give notice before <strong>{{ dates.after }}</strong> or you may have to reschedule your ceremony.</p>
                </ng-container>
                <p class="govuk-body" [innerHTML]="guidanceMessage" *ngIf="guidanceMessage.length > 0"></p>

                <h2>Give notice status</h2>
                <p class="govuk-body" [innerHTML]="giveNoticeGuidanceMessage" *ngIf="giveNoticeGuidanceMessage.length > 0"></p>
                <ul class="govuk-task-list">
                    <li class="govuk-task-list__item govuk-task-list__item">
                        <div class="govuk-task-list__name-and-hint">
                            <span
                                aria-describedby="ceremony-details-1-status">
                                Party 1 appointment date
                                <ng-container *ngIf="!giveNotice1FormEditing">
                                    <strong>{{ notice1Date }}</strong>
                                </ng-container>
                                <ng-container *ngIf="giveNotice1FormEditing">
                                    <form [formGroup]="giveNotice1Form">
                                        <input class="datepicker-give-notice" type="date" formControlName="notice" [ngClass]="{'error': !giveNotice1Form.pristine && giveNotice1Form.controls['notice'].errors?.required }">
                                    </form>
                                </ng-container>
                            </span>
                        </div>
                        <div class="btn-container">
                            <button (click)="setupGiveNotice1Form()" type="submit" class="btn btn-primary" data-module="govuk-button"
                                    [attr.aria-label]="!giveNotice1FormEditing && notice1Date.length < 1 ? 'edit party 1 notice date' : 
                                    giveNotice1FormEditing ? 'save party 1 notice date' : null">
                                <ng-container *ngIf="!giveNotice1FormEditing">
                                    Edit
                                </ng-container>
                                <ng-container *ngIf="giveNotice1FormEditing">
                                    Save
                                </ng-container>
                            </button>
                            <button (click)="cancelGiveNotice1Form()" type="submit" class="btn btn-primary" data-module="govuk-button"
                                *ngIf="giveNotice1FormEditing" aria-label="cancel editing of party 1 notice date">
                                Cancel
                            </button>
                        </div>
                        <div class="govuk-task-list__status" id="ceremony-details-1-status" *ngIf="notice1Date.length < 1 && !giveNotice1FormEditing">
                            <strong class="govuk-tag" >
                                Incomplete
                                <i class="ph ph-fill ph-warning-circle" aria-hidden="true"></i>
                            </strong>
                        </div>
                        <div class="govuk-task-list__status" id="ceremony-details-1-status"  *ngIf="notice1Date.length > 0 && !giveNotice1FormEditing" >
                            <strong class="govuk-tag completed" >
                                Completed
                                <i class="ph-fill ph-check-circle" aria-hidden="true"></i>
                            </strong>
                        </div>
                    </li>
                    <li class="govuk-task-list__item govuk-task-list__item">
                        <div class="govuk-task-list__name-and-hint">
                            <span
                                aria-describedby="ceremony-details-2-status">
                                Party 2 appointment date 
                                <ng-container *ngIf="!giveNotice2FormEditing">
                                    <strong>{{ notice2Date }}</strong>
                                </ng-container>
                                <ng-container *ngIf="giveNotice2FormEditing">
                                    <form [formGroup]="giveNotice2Form">
                                        <input class="datepicker-give-notice" type="date" formControlName="notice" [ngClass]="{'error': !giveNotice2Form.pristine && giveNotice2Form.controls['notice'].errors?.required }">
                                    </form>
                                </ng-container>
                            </span>
                        </div>
                        <div class="btn-container">
                            <button (click)="setupGiveNotice2Form()" type="submit" class="btn btn-primary"
                                    [attr.aria-label]="!giveNotice2FormEditing ? 'edit party 2 notice date' : 
                                    giveNotice2FormEditing ? 'save party 2 notice date' : null">
                                <ng-container *ngIf="!giveNotice2FormEditing">
                                    Edit
                                </ng-container>
                                <ng-container *ngIf="giveNotice2FormEditing">
                                    Save
                                </ng-container>
                            </button>
                            <button (click)="cancelGiveNotice2Form()" type="submit" class="btn btn-primary" *ngIf="giveNotice2FormEditing"
                                aria-label="cancel editing of party 2 notice date">
                                Cancel
                            </button>
                        </div>
                        <div class="govuk-task-list__status" id="ceremony-details-2-status" *ngIf="notice2Date.length < 1 && !giveNotice2FormEditing">
                            <strong class="govuk-tag" >
                                Incomplete
                                <i class="ph ph-fill ph-warning-circle" aria-hidden="true"></i>
                            </strong>
                        </div>
                        <div class="govuk-task-list__status" id="ceremony-details-2-status"  *ngIf="notice2Date.length > 0 && !giveNotice2FormEditing">
                            <strong class="govuk-tag completed" >
                                Completed
                                <i class="ph-fill ph-check-circle" aria-hidden="true"></i>
                            </strong>
                        </div>
                    </li>
                </ul>
                <ng-container *ngIf="bookNoticeGuidanceMessage.length > 0">
                    <h2>Book a notice appointment</h2>
                    <p class="govuk-body" [innerHTML]="bookNoticeGuidanceMessage"></p>
                </ng-container>
                <app-custom-object-accordion page="give-notice"></app-custom-object-accordion>
            </div>
        </main>
    </div>
</div>
